var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminarRojo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_521",
    "data-name": "Grupo 521",
    transform: "translate(-2093 -1352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght300_GRAD0_opsz40",
    d: "M182.061-801.875a1.2,1.2,0,0,1-.882-.37,1.2,1.2,0,0,1-.37-.882v-10.641H180.5a.485.485,0,0,1-.358-.145.49.49,0,0,1-.145-.36.481.481,0,0,1,.145-.357.49.49,0,0,1,.358-.143h2.978a.586.586,0,0,1,.179-.433.591.591,0,0,1,.431-.177h3.817a.588.588,0,0,1,.431.179.588.588,0,0,1,.179.431H191.5a.485.485,0,0,1,.358.145.49.49,0,0,1,.145.36.481.481,0,0,1-.145.357.49.49,0,0,1-.358.143h-.306v10.641a1.2,1.2,0,0,1-.37.882,1.2,1.2,0,0,1-.882.37Zm8.127-11.892h-8.373v10.641a.235.235,0,0,0,.072.177.242.242,0,0,0,.174.069h7.881a.242.242,0,0,0,.174-.069.235.235,0,0,0,.072-.177ZM184.5-804.54a.481.481,0,0,0,.357-.144.49.49,0,0,0,.143-.358v-6.576a.487.487,0,0,0-.145-.356.486.486,0,0,0-.36-.147.477.477,0,0,0-.357.147.492.492,0,0,0-.143.356v6.576a.485.485,0,0,0,.145.358A.49.49,0,0,0,184.5-804.54Zm3.013,0a.481.481,0,0,0,.357-.144.49.49,0,0,0,.143-.358v-6.576a.487.487,0,0,0-.145-.356.486.486,0,0,0-.36-.147.477.477,0,0,0-.357.147.492.492,0,0,0-.143.356v6.576a.485.485,0,0,0,.145.358A.49.49,0,0,0,187.51-804.54Zm-5.7-9.228v0Z",
    transform: "translate(1917.998 2171.383)",
    fill: "#d6063e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_340",
    "data-name": "Rect\\xE1ngulo 340",
    width: 22,
    height: 22,
    transform: "translate(2093 1352)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminarRojo);
export default __webpack_public_path__ + "static/media/eliminar_rojo.864b59642f0b27a20498bfb8235b15aa.svg";
export { ForwardRef as ReactComponent };